(function () {
  const DURATION = 500;
  const PRICE_SELECTOR =
    '.product-grid .price__regular .price-item--regular, .product-grid .price__sale .price-item--sale';

  function randomDigit() {
    return Math.floor(Math.random() * 10).toString();
  }

  function slotReveal(el) {
    const finalText = el.textContent.trim();
    const chars = finalText.split('');
    const digitIndexes = [];
    chars.forEach((char, index) => {
      if (/\d/.test(char)) digitIndexes.push(index);
    });
    if (digitIndexes.length === 0) return;

    const lockTimes = digitIndexes.map((_, order) => ((order + 1) / digitIndexes.length) * DURATION);
    const startTime = performance.now();

    el.setAttribute('aria-hidden', 'true');

    function tick(now) {
      const elapsed = now - startTime;
      const current = chars.slice();
      let allLocked = true;

      digitIndexes.forEach((charIndex, order) => {
        if (elapsed >= lockTimes[order]) {
          current[charIndex] = chars[charIndex];
        } else {
          current[charIndex] = randomDigit();
          allLocked = false;
        }
      });

      el.textContent = current.join('');

      if (!allLocked) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = finalText;
        el.removeAttribute('aria-hidden');
      }
    }

    requestAnimationFrame(tick);
  }

  function init(root) {
    const priceEls = (root || document).querySelectorAll(PRICE_SELECTOR);
    if (!priceEls.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            slotReveal(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -50px 0px' }
    );

    priceEls.forEach((el) => observer.observe(el));
  }

  document.addEventListener('DOMContentLoaded', () => init(document));

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  }
})();
